import {IEditor} from "@/customizer/interfaces";
import {IEditorImage, Imports} from "../editor.interfaces";



/* tslint:disable no-invalid-this */

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

const fabric = globalImports.fabric || (globalImports.fabric = {});
const SF = globalImports.SF || {};
SF.Editor = SF.Editor || {} as IEditor;
globalImports.SF.Editor = globalImports.SF.Editor || {};

/**
 * This extends PhotoGroup rather than Photo because all of Photo's positioning information is relative to center
 * of group. Room for possible future improvement.
 */
globalImports.SF.Editor.Background = fabric.util.createClass(globalImports.SF.Editor.PhotoGroup, {
    type: 'background',
    hoverCursor: 'initial',

    initialize: function(image:IEditorImage, options:any):void {
        options = options || {};

        // a background is always locked - no matter the data
        // options.locked = true;
        // options.fixed = true;
        options.hasControls = !options.isLetterBoxed;

        this.callSuper('initialize', image, null, options);
        this.setControlsVisibility({ bl:false, br: false, mb: false, ml: false, mr: false, mt: false, tl: false, tr: false, mtr: true});
    },

    letterBoxPhoto: function ():void {
        const snapAngle = Math.round(this.photoObject.angle / 90);
        // evaluates to true when the orientation of the photo has changed ie 90 / 207
        const  isRotated = snapAngle % 2 != 0;

        //rotate to nearest right angle
        this.sliderRotation(snapAngle * 90);

        this.isLetterBoxed = true;
        this.hasControls =  false;

        // adjust zoom and pan
        this.photoObject.placePhoto();

        //remove border / currently we can't support vignettes
        this.removeBorder();
        this.removeVignette();

        //when rotated 90 or 270 we must compare this.width to photoObject.height etc....
        if(isRotated) {
            //compare aspect rations of the zone to the photo
            if (this.width / this.height < this.photoObject.height / this.photoObject.width) {
                this.photoObject.width = this.photoObject.width *  (this.width / this.photoObject.height);
                //noinspection JSSuspiciousNameCombination
                this.photoObject.height = this.width;
                this.photoObject.imagePosition.zoom = this.width /  this.photoObject.imagePosition.height;
                this.photoObject.imagePosition.x = (this.width / -2) - ((this.photoObject.height - this.photoObject.width) / -2);
                this.photoObject.imagePosition.y = (this.photoObject.width / -2 ) + ((this.photoObject.height - this.photoObject.width) / -2);
            } else {
                this.photoObject.height = this.photoObject.height *  (this.height / this.photoObject.width);
                //noinspection JSSuspiciousNameCombination
                this.photoObject.width = this.height;
                this.photoObject.imagePosition.zoom = this.height /  this.photoObject.imagePosition.width;
                this.photoObject.imagePosition.x = (this.photoObject.height / -2 ) + ((this.photoObject.width - this.photoObject.height) / -2);
                this.photoObject.imagePosition.y = (this.height / -2) - ((this.photoObject.width - this.photoObject.height) / -2);
            }
        } else {
            //compare aspect rations of the zone to the photo
            if(this.width / this.height < this.photoObject.width / this.photoObject.height) {
                this.photoObject.height = this.photoObject.height *  (this.width / this.photoObject.width);
                this.photoObject.width = this.width;
                this.photoObject.imagePosition.zoom = this.width /  this.photoObject.imagePosition.width;
                this.photoObject.imagePosition.x = this.width / -2;
                this.photoObject.imagePosition.y = this.photoObject.height / -2;
            } else {
                this.photoObject.width = this.photoObject.width *  (this.height / this.photoObject.height);
                this.photoObject.height = this.height;
                this.photoObject.imagePosition.zoom = this.height /  this.photoObject.imagePosition.height;
                this.photoObject.imagePosition.x = this.photoObject.width / -2;
                this.photoObject.imagePosition.y = this.height / -2;
            }
        }

    },

    removeLetterBox: function ():void {
        this.isLetterBoxed = false;
        this.hasControls = true;
        // zoom back out
        this.photoObject.placePhoto();
    },

    toObject: function (propertiesToInclude:boolean):fabric.Object {
        const o = fabric.util.object.extend(this.callSuper('toObject', propertiesToInclude), {
            isLetterBoxed: this.isLetterBoxed
        });

        delete o.src;

        return o;
    },
});